import client from '../client'

export const getVehicleKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetVehicle`

export async function getVehicle({ vehicleId }) {
  const params = new URLSearchParams({ vehicleId })

  return client(`${getVehicleKey}?${params.toString()}`).then((res) => res.vehicle)
}
